export enum RosState {
  Stop = 0,
  Manual = 1,
  Auto = 2
}
